import * as L from 'leaflet';

// trips GeoJSON parsing and rendering on map is same for both the map widget and main website map
export default function(context, data, lat, lng) {
  // instance of L.map
  const map = context;
  // only render data with geometry type of LineString
  const filtered = data.features.filter(feature => feature.geometry.type == 'LineString');
  // placeholders for GeoJSON features that can be accessed from this function's inner scope
  let trailTop;
  let trailBottom;
  let boundsToFit;

  function render() {
    // NOTE: trip paths are added to the map twice so that the needs of the cartographic style can be met
    // bottom / outer casing
    trailBottom = L.geoJSON(filtered, {
      style: {
        color: '#FFFFFF',
        dashArray: '0,10',
        weight: 8
      }
    }).addTo(map);

    // top / inner casing
    trailTop = L.geoJSON(filtered, {
      style: {
        color: '#008E9A',
        dashArray: '0,10',
        weight: 6,
      }
    }).addTo(map);

    // make sure to fit the map bounds to both the trip path GeoJSON and trip start marker coords
    boundsToFit = {
      type: 'FeatureCollection',
      features: [
        ...filtered,
        {
          type: 'Point',
          coordinates: [lng, lat]
        }
      ]
    }

    // fit map bounds to the trip
    map.fitBounds(L.geoJson(boundsToFit).getBounds());
  }

  render.tripPathBottom = function() {
    return trailBottom;
  }

  render.tripPathTop = function() {
    return trailTop;
  }

  render.boundsToFit = function() {
    return boundsToFit;
  }

  return render;
};



// WEBPACK FOOTER //
// ./utils/renderTripPaths.js